import React, { useState, useEffect } from 'react';
import { getPartnerships } from './api/api';
import Partnerships from './components/Partnerships';
import PartnershipDetail from './components/PartnershipDetail';
import Schedule from './components/Schedule';
import Reports from './components/Reports';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import UserManagement from './components/UserManagement';
import BackupModal from './components/BackupModal';
import ReportView from './components/ReportView';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [page, setPage] = useState(() => sessionStorage.getItem('currentPage') || 'partnerships');
  const [savedPartnershipId] = useState(() => sessionStorage.getItem('currentPartnershipId'));
  const [selectedPartnership, setSelectedPartnership] = useState(null);

  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')||'null'));
  const [partnerships, setPartnerships] = useState([]);
  const [showBackup, setShowBackup] = useState(false);
  const [appLoading, setAppLoading] = useState(true);
  useEffect(() => {
    sessionStorage.setItem('currentPage', page);
    if (selectedPartnership) sessionStorage.setItem('currentPartnershipId', selectedPartnership.id);
  }, [page, selectedPartnership]);
  useEffect(() => {
    if (token) {
      import('./api/api').then(m => m.default.get('/partnerships/').then(r => {
        const u = JSON.parse(localStorage.getItem('user')||'null');
        const allP = r.data;
        if(u && u.role !== 'admin' && u.partnership_id) {
          const filtered = allP.filter(p => Number(p.id) === Number(u.partnership_id));
          setPartnerships(filtered);
          if(filtered.length > 0) {
            setSelectedPartnership(filtered[0]);
            const perms = u.permissions || [];
            if(u.role === 'operator') setPage('schedule');
            else if(u.role === 'partner') setPage('reports');
            else if(perms.includes('schedule')) setPage('schedule');
            else if(perms.includes('whatsapp')) setPage('whatsapp');
            else if(perms.includes('summary')) setPage('summary');
            else if(perms.includes('expenses')) setPage('expenses');
            else if(perms.includes('revenues')) setPage('revenues');
            else if(perms.includes('reports')) setPage('reports');
            else setPage('detail');
          }
        } else {
          setPartnerships(allP);
          const savedId = sessionStorage.getItem('currentPartnershipId');
          const savedPg = sessionStorage.getItem('currentPage');
          if (savedId && savedPg && savedPg !== 'partnerships') {
            const found = allP.find(p => String(p.id) === String(savedId));
            if (found) { setSelectedPartnership(found); setPage(savedPg); }
          }
        }
        setAppLoading(false);
      }).catch(() => setAppLoading(false)));
    }
  }, [token]);
  const [showForgot, setShowForgot] = React.useState(false);
  const handleLogin = (userData) => { localStorage.setItem('token', userData.token); localStorage.setItem('user', JSON.stringify(userData)); setToken(userData.token); setUser(userData); };
  const handleLogout = () => { localStorage.removeItem('token'); localStorage.removeItem('user'); setToken(null); setUser(null); };


  const pathMatch = window.location.pathname.match(/^\/r\/([^/]+)/);
  if (pathMatch) {
    return <ReportView token={pathMatch[1]} />;
  }
  if (!token) return showForgot ? <ForgotPassword onBack={()=>setShowForgot(false)} /> : <Login onLogin={handleLogin} onForgot={()=>setShowForgot(true)} />;
  if (appLoading) return <div style={{display:'flex',justifyContent:'center',alignItems:'center',minHeight:'100vh',fontSize:'18px',color:'#1e3a5f'}}>💧 جاري التحميل...</div>;

  return (
    <div style={{ minHeight:'100vh', background:'#f0f4f8', fontFamily:'Tajawal, Arial, sans-serif' }} dir="rtl">
      <header style={{ background:'#1e3a5f', color:'white', padding:'12px 20px', display:'flex', justifyContent:'space-between', alignItems:'center', boxShadow:'0 2px 8px rgba(0,0,0,0.2)' }}>
        <h1 style={{ margin:0, fontSize:'18px', cursor:'pointer' }} onClick={() => { setPage('partnerships'); setSelectedPartnership(null); }}>
          💧 نظام إدارة شراكات الآبار
        </h1>
        <div style={{ display:'flex', gap:'10px', alignItems:'center' }}>

          {selectedPartnership && user?.role === 'operator' && (
            <span style={{fontSize:'14px',color:'#adc8e6',fontWeight:'bold'}}>
              💧 {selectedPartnership.name}
            </span>
          )}
          {user?.role==='admin' && <button onClick={()=>{setPage('users');setSelectedPartnership(null);}}
            style={{padding:'6px 12px',background:page==='users'?'white':'transparent',color:page==='users'?'#1e3a5f':'white',border:'1px solid white',borderRadius:'5px',cursor:'pointer',fontSize:'13px'}}>
            👥 المستخدمين
          </button>}
          {user && <span style={{fontSize:'13px',color:'#adc8e6'}}>👤 {user.name||user.username}</span>}
          <button onClick={handleLogout}
            style={{ padding:'6px 12px', background:'#e74c3c', color:'white', border:'none', borderRadius:'5px', cursor:'pointer', fontSize:'13px' }}>
            🚪 خروج
          </button>
        </div>
      </header>

      <main style={{ maxWidth:'1400px', margin:'0 auto', padding:'10px' }}>
      {showBackup && <BackupModal onClose={()=>setShowBackup(false)} user={user} partnerships={partnerships} />}
      {page === 'users' && (
        <div style={{padding:'20px',maxWidth:'1000px',margin:'0 auto'}}>
          <div style={{marginBottom:'15px'}}>
            <button onClick={()=>setPage('partnerships')} style={{padding:'8px 16px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
              ← رجوع للرئيسية
            </button>
          </div>
          <UserManagement partnerships={partnerships} />
        </div>
      )}
        {page === 'partnerships' && !selectedPartnership && (
          <div>
            {user && user.role==='admin' && (
              <div style={{padding:'10px 20px',background:'#fff',borderBottom:'1px solid #e0e0e0',display:'flex',gap:'10px'}}>
                <button onClick={()=>setShowBackup(true)} style={{padding:'8px 16px',background:'#27ae60',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontWeight:'bold',fontSize:'13px'}}>
                  💾 نسخة احتياطية
                </button>
              </div>
            )}
            <Partnerships onSelect={(p) => { setSelectedPartnership(p); setPage('detail'); }} />
          </div>
        )}
        {page === 'detail' && selectedPartnership &&
          <PartnershipDetail partnership={selectedPartnership}
            onBack={() => { setSelectedPartnership(null); setPage('partnerships'); }}
            onSchedule={() => setPage('schedule')} onReports={() => setPage('reports')} />}
      {page === 'reports' && selectedPartnership && <Reports partnership={selectedPartnership} onBack={() => setPage('detail')} />}
        {page === 'schedule' && selectedPartnership &&
          <Schedule partnership={selectedPartnership}
            onBack={() => setPage('detail')} />}
      </main>
    </div>
  );
}

export default App;
